import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import UnifiedApp from './UnifiedApp';
import RetatrutideCalculator from './pages/RetatrutideCalculator';
import TirzepatideCalculator from './pages/TirzepatideCalculator';
import SemaglutideCalculator from './pages/SemaglutideCalculator';
import BPC157Calculator from './pages/BPC157Calculator';
import CJC1295Calculator from './pages/CJC1295Calculator';
import IpamorelinCalculator from './pages/IpamorelinCalculator';
import PeptideComparison from './pages/PeptideComparison';
import DosageConverter from './pages/DosageConverter';
import FAQPage from './pages/FAQPage';
import GuidesIndex from './pages/GuidesIndex';
import RetatrutideGuide from './pages/guides/RetatrutideGuide';
import TirzepatideVsSemaglutide from './pages/guides/TirzepatideVsSemaglutide';
import GLP1SideEffects from './pages/guides/GLP1SideEffects';
import PeptideReconstitution from './pages/guides/PeptideReconstitution';

function AppMain() {
  return (
    <Router>
      <Routes>
        {/* Specific peptide calculator routes */}
        <Route path="/retatrutide-calculator" element={<RetatrutideCalculator />} />
        <Route path="/tirzepatide-calculator" element={<TirzepatideCalculator />} />
        <Route path="/semaglutide-calculator" element={<SemaglutideCalculator />} />
        <Route path="/bpc-157-calculator" element={<BPC157Calculator />} />
        <Route path="/cjc-1295-calculator" element={<CJC1295Calculator />} />
        <Route path="/ipamorelin-calculator" element={<IpamorelinCalculator />} />
        
        {/* Tools and Comparison Pages */}
        <Route path="/peptides/compare" element={<PeptideComparison />} />
        <Route path="/tools/dosage-converter" element={<DosageConverter />} />
        
        {/* FAQ Page */}
        <Route path="/faq" element={<FAQPage />} />
        
        {/* Guides Routes */}
        <Route path="/guides" element={<GuidesIndex />} />
        <Route path="/guides/retatrutide-complete-guide" element={<RetatrutideGuide />} />
        <Route path="/guides/tirzepatide-vs-semaglutide" element={<TirzepatideVsSemaglutide />} />
        <Route path="/guides/glp1-side-effects" element={<GLP1SideEffects />} />
        <Route path="/guides/peptide-reconstitution" element={<PeptideReconstitution />} />
        
        {/* Main app with all other routes */}
        <Route path="*" element={<UnifiedApp />} />
      </Routes>
    </Router>
  );
}

export default AppMain;